import * as React from 'react';
import * as PropTypes from 'prop-types';
import {AlertItemProps} from '../../types/components';
import AssetsManager from '../../utils/AssetsManager';

export default class AlertItem extends React.Component<AlertItemProps, {}> {

    static propTypes = {
        alertTitle: PropTypes.string,
        alertText: PropTypes.string,
        removeAlert: PropTypes.func
    };

    componentDidMount() {
        setTimeout(
            () => {
                this.props.removeAlert();
            },
            5000
        );
    }

    render() {
        const {alertTitle, alertText, alertType} = this.props;
        return (
            <React.Fragment>
                {!alertType &&
                <div className="alerts-container2 alert-align-right">
                    <div className="d-flex justify-content-between">
                        <div className="alert-line">{}</div>
                        <div className="px-3 pt-2">
                            <img src={AssetsManager('/assets/images/common/pdf-icon-select.svg')}
                                 width="48" height="48" alt="pdf logo"/>
                        </div>
                        <div className="mr-4">
                            <div className="alert-title">{alertTitle}</div>
                            <div className="regular-text">{alertText}</div>
                        </div>
                        <div>
                            <img src={AssetsManager('/assets/images/common/modal-close-icon.svg')}
                                 width="16" height="16"
                                 alt="close" className="close float-right"
                                 onClick={() => this.props.removeAlert()}/>
                        </div>
                    </div>
                </div>}
                {alertType && <div className="alerts-container" dangerouslySetInnerHTML={{__html: alertTitle}}/>}
            </React.Fragment>
        );
    }

}
